module.exports = __webpack_public_path__ + "img/f-1.dc57f83c.jpg";